function isServer() {
  return typeof window === "undefined" && typeof global !== "undefined";
}

export { isServer };
//# sourceMappingURL=isServer.mjs.map
